module.exports = __webpack_public_path__ + "img/Wessel_Kierlighed_uden_Strømper.babc8810.jpg";